// extracted by mini-css-extract-plugin
export var blue = "Card-module--blue--a6613";
export var brightBlue = "Card-module--brightBlue--72e37";
export var card = "Card-module--card--f5e30";
export var dark = "Card-module--dark--f0535";
export var darkBlue = "Card-module--darkBlue--b88df";
export var darkGray = "Card-module--darkGray--6c90e";
export var lightGray = "Card-module--lightGray--ead52";
export var linearBlue = "Card-module--linearBlue--cd506";
export var linearDarkBlue = "Card-module--linearDarkBlue--3fdf4";
export var linearSeaGreen = "Card-module--linearSeaGreen--5a8b2";
export var offWhite = "Card-module--offWhite--d1afc";
export var seaGreen = "Card-module--seaGreen--45935";
export var simple = "Card-module--simple--06250";
export var softWhite = "Card-module--softWhite--09caa";
export var transparent = "Card-module--transparent--3dfee";
export var white = "Card-module--white--5ff13";